import { render, staticRenderFns } from "./LineHeight.vue?vue&type=template&id=42e08f02&scoped=true"
import script from "./LineHeight.vue?vue&type=script&lang=js"
export * from "./LineHeight.vue?vue&type=script&lang=js"
import style0 from "./LineHeight.vue?vue&type=style&index=0&id=42e08f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e08f02",
  null
  
)

export default component.exports